module.exports = __webpack_public_path__ + "img/ico-30-close.200dd765.svg";